export default "__VITE_ASSET__a7b5e405__"